import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { actions } from '../../store/ducks/app';
import TStore from '../../types/store';
import { TGlobalModalId } from '../../types/app';
import Modal from '../../components/modal';
// import FinishProfile from '../../components/finish-profile';
import Integration from '../../components/integration';
import { SHOWED_INT_MODAL } from '../../constants/local-storage';

const GlobalModal: React.FC = () => {
  const dispatch = useDispatch();
  const showModal = useSelector((store: TStore) => store.app.showGlobalModal);
  const modalId: TGlobalModalId | null = useSelector((store: TStore) => store.app.globalModalId);
  const modalPayload: any = useSelector((store: TStore) => store.app.globalModalPayload);

  const onRequestClose = () => {
    if (modalId === 'CONNECT_SOFTWARE') {
      localStorage.setItem(SHOWED_INT_MODAL, 'true');
    }
    dispatch(actions.closeModal());
  };

  const renderModal = () => {
    if (modalId) {
      switch (modalId) {
        case 'CONNECT_SOFTWARE':
          return <Integration onProceed={() => dispatch(actions.closeModal())} />;
        // case 'FINISH_PROFILE':
        //   return <FinishProfile />;
        case 'IMAGE':
          return (
            <>
              <div>{modalPayload.caption || ''}</div>
              <img src={modalPayload.imgUrl} width="100%" alt="" />
            </>
          );
        default:
          return null;
      }
    }
    return null;
  };

  return (
    <Modal isOpen={showModal} onRequestClose={onRequestClose} showClose={modalId === 'IMAGE'}>
      {renderModal()}
    </Modal>
  );
};

export default GlobalModal;
